export const primaryButton = {
  button: {
    backgroundColor: '#0099CE',
    border: 'none',
    borderRadius: '15px',
    color: '#FFF',
    cursor: 'pointer',
    fontSize: '15px',
    minHeight: '30px',
    marginLeft: '20px',
    padding: '5px 28px 7px 28px',
    outline: 'none',
  },
};

export const customPrimaryButton = {
  button: {
    backgroundColor: '#0099CE',
    border: 'none',
    borderRadius: '15px',
    color: '#FFF',
    cursor: 'pointer',
    fontSize: '15px',
    minHeight: '30px',
    padding: '5px 18px 7px 18px',
    outline: 'none',
  },
};

export const redButton = {
  button: {
    backgroundColor: '#C50019',
    border: 'none',
    borderRadius: '15px',
    color: '#FFF',
    cursor: 'pointer',
    fontSize: '15px',
    minHeight: '30px',
    padding: '5px 28px 7px 28px',
    justifySelf: 'flex-end',
    outline: 'none',
  },
};
